export default {
      id: "upload-usage",
      viewBox: "0 0 30 30",
      url: "/assets/" + "icons.svg#upload",
      toString: function () {
        return this.url;
      }
    }